import { render, staticRenderFns } from "./PickupItemDetails.vue?vue&type=template&id=4502e57e&scoped=true"
import script from "./PickupItemDetails.vue?vue&type=script&lang=ts"
export * from "./PickupItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./PickupItemDetails.vue?vue&type=style&index=0&id=4502e57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502e57e",
  null
  
)

export default component.exports